import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useLivePersonaCard } from 'owa-persona/lib/components/PersonaCardBehavior';
import PersonaControl from 'owa-persona/lib/components/PersonaControl';
import { PersonaSize } from '@fluentui/react/lib/Persona';
import * as styles from './styles.scss';

export default observer(function PersonaIcon({
    name,
    emailAddress,
    className,
    showName = true,
    personaSize = PersonaSize.size24,
    tabIndex,
    personaCardBehaviorDisabled,
}: {
    name: string;
    emailAddress: string;
    className?: string;
    showName?: boolean;
    personaSize?: PersonaSize;
    tabIndex?: number;
    personaCardBehaviorDisabled?: boolean;
}) {
    const PersonaCardBehavior = useLivePersonaCard({
        className: styles.personaWrapper,
        name: name,
        emailAddress: emailAddress,
        tabIndex: tabIndex,
    });

    const content = (
        <div className={styles.persona}>
            <PersonaControl
                name={name}
                emailAddress={emailAddress}
                size={personaSize}
                data-is-focusable={!tabIndex || tabIndex >= 0}
            />
            {showName && <span className={styles.personaName}>{name}</span>}
        </div>
    );

    return personaCardBehaviorDisabled ? (
        content
    ) : (
        <PersonaCardBehavior>{content}</PersonaCardBehavior>
    );
});
